import React, { FunctionComponent, SVGProps } from 'react';
import { useTheme } from 'styled-components';

export interface TrackIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  isInvertedTheme?: boolean;
}

export const TrackIcon: FunctionComponent<TrackIconProps> = ({
  className,
  isInvertedTheme,
  ...props
}) => {
  const theme = useTheme();

  const getBGColor = () => {
    if (isInvertedTheme) {
      return theme.colors.primary;
    }

    return theme.colors.box;
  };

  const getPathColor = () => {
    if (isInvertedTheme) {
      return theme.colors.box;
    }

    return theme.colors.primary;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className || ''}
      {...props}
    >
      <circle fill={getBGColor()} cx="12" cy="12" r="12" />
      <path
        fill={getPathColor()}
        d="M13.39,15.25h-.55v-6.52h2.41v.71c0,.19,.08,.37,.21,.5,.13,.13,.32,.21,.51,.21h.32c.19,0,.37-.08,.51-.21,.13-.13,.21-.31,.21-.5v-1.73c0-.19-.08-.37-.21-.5-.13-.13-.32-.21-.51-.21H7.71c-.19,0-.37,.08-.51,.21-.13,.13-.21,.31-.21,.5v1.73c0,.19,.08,.37,.21,.5,.13,.13,.32,.21,.51,.21h.27c.19,0,.37-.08,.51-.21,.13-.13,.21-.31,.21-.5v-.71h2.4v6.52h-.55c-.19,0-.37,.08-.51,.21-.13,.13-.21,.31-.21,.5v.32c0,.19,.08,.37,.21,.5,.13,.13,.32,.21,.51,.21h2.86c.19,0,.37-.08,.51-.21,.13-.13,.21-.31,.21-.5v-.32c0-.09-.02-.19-.06-.28-.04-.09-.09-.17-.16-.23-.07-.07-.15-.12-.24-.15-.09-.03-.18-.05-.28-.05Z"
      />
    </svg>
  );
};

export default TrackIcon;
